import { showToast } from '~/components/App/toast/showToast';
import { ServiceRequestConfig } from '~/services/createService';

export function showAccessControlSuccessToast(
  options: ServiceRequestConfig = {},
  responseMessage?: string,
) {
  if (!options.showSuccessToast) {
    return;
  }

  const message =
    typeof options.showSuccessToast === 'string'
      ? options.showSuccessToast
      : responseMessage;

  if (!message) {
    return;
  }

  showToast({
    status: 'positive',
    text: message,
  });
}
